/* eslint-disable */
import React from 'react';

export type MisconceptionCardIconRender = (active: boolean) => React.ReactNode;

export const HCG_ICONS: MisconceptionCardIconRender[] = [
  // 文件
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15h6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  // 锁
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 22.0001V14.0001C13.9975 11.5202 14.9166 9.12779 16.5787 7.2874C18.2409 5.447 20.5277 4.28987 22.995 4.04064C25.4624 3.79141 27.9343 4.46787 29.9309 5.93869C31.9276 7.40951 33.3065 9.56976 33.8 12.0001M10 22.0001H38C40.2091 22.0001 42 23.7909 42 26.0001V40.0001C42 42.2092 40.2091 44.0001 38 44.0001H10C7.79086 44.0001 6 42.2092 6 40.0001V26.0001C6 23.7909 7.79086 22.0001 10 22.0001Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 信息
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M12 8v.01M12 12v4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  // 图片
  (active: boolean) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
      <path
        d="M21 15l-5-5L5 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const FAKE_WEBSITE_CARD_ICONS: MisconceptionCardIconRender[] = [
  // 电脑显示器
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6"
        y="12"
        width="60"
        height="40"
        rx="4"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 22H66"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 52V58"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 58H42"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 添加用户
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="24"
        cy="20"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 58C8 46.9543 16.9543 38 28 38"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48 18V34"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 26H56"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 播放箭头
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 12L60 36L16 60V12Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 显示器警告
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10"
        y="10"
        width="52"
        height="38"
        rx="4"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 20H62"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 40L26 52H46L36 40Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const FCG_ICONS: MisconceptionCardIconRender[] = [
  // 信封 - 电邮钓鱼
  (active: boolean) => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 12C4 9.79086 5.79086 8 8 8H40C42.2091 8 44 9.79086 44 12V36C44 38.2091 42.2091 40 40 40H8C5.79086 40 4 38.2091 4 36V12Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12L24 28L44 12"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 对话气泡 - 短讯及即时讯息
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63 45C63 46.5913 62.3679 48.1174 61.2426 49.2426C60.1174 50.3679 58.5913 51 57 51H21L9 63V15C9 13.4087 9.63214 11.8826 10.7574 10.7574C11.8826 9.63214 13.4087 9 15 9H57C58.5913 9 60.1174 9.63214 61.2426 10.7574C62.3679 11.8826 63 13.4087 63 15V45Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 开关/窗口 - 社交平台冒充
  (active: boolean) => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="6"
        y="8"
        width="36"
        height="32"
        rx="3"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="12"
        y="14"
        width="8"
        height="20"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="28"
        y="14"
        width="4"
        height="10"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 电话 - 深伪内容及假冒来电
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.1503 15C48.0805 15.5717 50.7734 17.0048 52.8845 19.1158C54.9955 21.2268 56.4286 23.9198 57.0003 26.85M45.1503 3C51.2381 3.67631 56.9151 6.40252 61.249 10.731C65.583 15.0595 68.3163 20.733 69.0003 26.82M66.0003 50.76V59.76C66.0037 60.5955 65.8325 61.4225 65.4978 62.188C65.1631 62.9536 64.6722 63.6408 64.0565 64.2056C63.4409 64.7704 62.714 65.2004 61.9225 65.4681C61.1311 65.7358 60.2924 65.8352 59.4603 65.76C50.2288 64.7569 41.3613 61.6024 33.5703 56.55C26.3218 51.944 20.1763 45.7985 15.5703 38.55C10.5002 30.7236 7.34502 21.813 6.36029 12.54C6.28532 11.7104 6.38391 10.8743 6.64979 10.0849C6.91567 9.29547 7.343 8.57007 7.90459 7.95486C8.46617 7.33966 9.1497 6.84813 9.91166 6.51157C10.6736 6.175 11.4973 6.00078 12.3303 6H21.3303C22.7862 5.98567 24.1977 6.50124 25.3016 7.4506C26.4055 8.39996 27.1265 9.71834 27.3303 11.16C27.7102 14.0402 28.4146 16.8682 29.4303 19.59C29.8339 20.6638 29.9213 21.8307 29.682 22.9526C29.4427 24.0745 28.8869 25.1043 28.0803 25.92L24.2703 29.73C28.541 37.2406 34.7597 43.4593 42.2703 47.73L46.0803 43.92C46.896 43.1134 47.9257 42.5575 49.0476 42.3183C50.1695 42.079 51.3365 42.1664 52.4103 42.57C55.1321 43.5857 57.9601 44.2901 60.8403 44.67C62.2976 44.8756 63.6285 45.6096 64.5799 46.7325C65.5313 47.8554 66.0368 49.2887 66.0003 50.76Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const SUSPICIOUS_MESSAGE_ICONS: MisconceptionCardIconRender[] = [
  // 垃圾桶 - 刻意催促立即處理
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12H10M10 12H42M10 12V40C10 41.0609 10.4214 42.0783 11.1716 42.8284C11.9217 43.5786 12.9391 44 14 44H34C35.0609 44 36.0783 43.5786 36.8284 42.8284C37.5786 42.0783 38 41.0609 38 40V12M16 12V8C16 6.93913 16.4214 5.92172 17.1716 5.17157C17.9217 4.42143 18.9391 4 20 4H28C29.0609 4 30.0783 4.42143 30.8284 5.17157C31.5786 5.92172 32 6.93913 32 8V12M20 22V34M28 22V34"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 禁止符号 - 內容與情境不符
  (active: boolean) => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="2.5" />
      <path
        d="M11.1 11.1L36.9 36.9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  // 用户+叉号 - 連結名稱與實際去向不一致
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 42V38C32 35.8783 31.1571 33.8434 29.6569 32.3431C28.1566 30.8429 26.1217 30 24 30H10C7.87827 30 5.84344 30.8429 4.34315 32.3431C2.84285 33.8434 2 35.8783 2 38V42M36 16L46 26M46 16L36 26M25 14C25 18.4183 21.4183 22 17 22C12.5817 22 9 18.4183 9 14C9 9.58172 12.5817 6 17 6C21.4183 6 25 9.58172 25 14Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 开关/滑块 - 要求提供不必要資料
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6V42M10 6H38C40.2091 6 42 7.79086 42 10V38C42 40.2091 40.2091 42 38 42H10C7.79086 42 6 40.2091 6 38V10C6 7.79086 7.79086 6 10 6Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];
